$(document).ready(function(){
  $('.cookies button').click(function(e){
    $.cookie('hzd_cookie_consented', 'true', { path: '/', expires: 365 });
    $('.cookies').fadeOut("slow");
  });
});



// WEBPACK FOOTER //
// app/frontend/javascripts/cookies.js